import { Card } from "@/components/ui/card";

export default function StatCard({ label, value, icon: Icon, accent = "var(--tenant-primary)", sub, testid }) {
  return (
    <Card data-testid={testid} className="p-5 border-slate-200 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-slate-400">{label}</p>
          <p className="font-display text-3xl font-bold text-slate-900 mt-2 leading-none">{value}</p>
          {sub && <p className="text-xs text-slate-400 mt-1.5">{sub}</p>}
        </div>
        {Icon && (
          <div className="h-10 w-10 rounded-md flex items-center justify-center" style={{ background: `${accent}14` }}>
            <Icon size={20} style={{ color: accent }} />
          </div>
        )}
      </div>
    </Card>
  );
}
